<template>
  <section class="no-location">
    <div>
      <p>There are no locations, please </p>
      <button
        class="button is-white"
        @click="handleAddLocation()"
      >
        create location
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NoLocation',
  props: {
    handleAdd: Function
  },
  methods: {
    handleAddLocation() {
      if (typeof this.handleAdd === 'function') {
        this.handleAdd();
        return;
      }
      this.$store.commit('setSelectedOrganization', { organization: this.$store.state.organization });
      this.$root.showLocationAdd = true;
      this.$router.push({ name: 'company' });
    }
  }
};
</script>
<style scoped lang="scss">
    .no-location {
        padding: 10px 0;

        div {
            display: flex;
            align-items: center;

            button {
                border: none;
                outline: none;
                background: none !important;
                cursor: pointer;
                color: #6279FF;
                padding: 0;
                height: unset;
                margin-left: 5px;

                &:hover {
                    color: #000;
                }
            }
        }
    }
</style>
